import React from 'react';

export const ErrorFallback = () => {
  return (
    <div className="min-h-screen pt-16 pb-12 flex flex-col bg-white">
      <main className="flex-grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-16">
          <div className="text-center">
            <p className="text-sm font-semibold text-whatis-600 uppercase tracking-wide">
              Uh oh.
            </p>
            <h1 className="mt-2 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
              Something went wrong
            </h1>
            <div className="mt-6">
              <a href="/">
                <div className="text-base font-medium text-whatis-600 hover:text-whatis-500">
                  Take me home<span aria-hidden="true"> &rarr;</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
